import { render, staticRenderFns } from "./ChatterProjectNew.vue?vue&type=template&id=22aecbfc"
import script from "./ChatterProjectNew.vue?vue&type=script&lang=js"
export * from "./ChatterProjectNew.vue?vue&type=script&lang=js"
import style0 from "./ChatterProjectNew.vue?vue&type=style&index=0&id=22aecbfc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports